export default {
    init() {
        this.clientStatisticFilter();
        this.phoneSelectInit();
        this.clientDocumentsGallery();
        this.clientDocumentsRotate();
        this.dateSelectInit();
    },

    clientStatisticFilter(){
        $('.client-statistics-filter').slick({
            infinite: true,
            slidesToShow: 4,
            arrows: true,
        });
    },

    phoneSelectInit(){
        $(".contact-phone").intlTelInput({
            separateDialCode:true,
            initialCountry:"LT",
        });
    },

    clientDocumentsGallery() {
        let slider = $('.client-document--gallery--main-slider');
        let selector = $('.client-document--gallery--main-slider .slick-slide a');

        slider.slick({
            slidesToShow: 1,
            dots: false,
            infinite: false,
            arrows: false,
            speed: 300,
            autoplay: false,
            slidesToScroll: 1,
            fade: true,
        });

        selector.fancybox({
            loop: false,
            infobar: false,
            hash: false,
            backFocus: false,
            animationEffect: "fade",
            padding: 0,
            thumbs: {
                autoStart: false
            },
            buttons: [
                'slideShow',
                'fullScreen',
                'close'
            ]
        });

        let navItems = $('.client-document--gallery--navigation .item');
        let galleryItems = $('.client-document--gallery--main-slider .slick-slide');
        let fancyboxItems = $('.client-document--gallery--main-slider .slick-slide a');

        navItems.eq(0).addClass('active');

        // counter
        if (galleryItems.length > navItems.length) {
            $('.client-document--gallery--navigation .item.counter span').html( '+' + (galleryItems.length -11).toString());
        } else {
            $('.client-document--gallery--navigation .item.counter').remove();
        }

        // navigation click
        navItems.on('click', function () {
            let thisIndex = $(this).index();

            fancyboxItems.eq(thisIndex).trigger('click');
            navItems.removeClass('active');
            navItems.eq(thisIndex).addClass('active');
            slider.slick('slickGoTo', thisIndex);
        });

        // slider change
        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            navItems.removeClass('active');
            navItems.eq(nextSlide).addClass('active');

            if (nextSlide + 1 === 12) {
                fancyboxItems.eq(nextSlide).trigger('click');
            }
        });
    },

    clientDocumentsRotate() {
        var rotateDegrees = 0;
        $('.document-rotate-right').on('click', function () {
            rotateDegrees += 90;
            $(this).parent().parent().find('.img').css("transform","rotate(" + rotateDegrees + "deg)");
        })

        $('.document-rotate-left').on('click', function () {
            rotateDegrees -= 90;
            $(this).parent().parent().find('.img').css("transform","rotate(" + rotateDegrees + "deg)");
        })
    },

    dateSelectInit(){
        let select = $('.date-select select');
        if (select.length > 0) {
            select.select2({ dropdownAutoWidth: true, width: 'resolve'});
        }
    },
}